/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-05-15 14:37:23
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-09 18:56:39
 */
import { reactivate } from "@/api/modules/plan";

export default {
	"billing.blank.text": "Start your 7-day free trial and make the most of your ads budget now!",

	"billing.blank.button.cancel try": "Cancel Trial",
	"billing.blank.button.now renew": "Renew Subscription",
	"billing.blank.button.Pay Now": "Pay Now",
	"billing.blank.button.Purchase Subscription": "Purchase Subscription",
	"billing.blank.button.Confirm Cancellation": "Confirm Cancellation",
	"billing.blank.button.Confirm Cancellation button": "确认取消",
	"billing.blank.button.Cancellation.try.title": "取消试用后，已使用的代金券将不予返还。是否仍要取消试用？",
	"billing.blank.button.upgrade": "Upgrade Plan",

	"billing.blank.button": "Upgrade",
	"billing.free.user.button": "Auto-renew",

	"billing.plan.name.standard": "Standard Plan",
	"billing.plan.name.professional": "Professional Plan",
	"billing.title": "Billing for {{name}}",
	"billing.trialText": "Trial expiry date: {{count}}",
	"billing.notExpireText": "Subscription expiry date: {{count}}",
	"billing.expiredText": "Your subscription has expired",

	"billing.plan.title": "You are on the",
	"billing.plan.item.unlimitedProfiles": "Unlimited profiles",
	"billing.plan.item.accounts": "{{limit}} accounts connected",
	"billing.plan.item.rule": "{{ruleLimit}} automated rules with {{activeLimit}} ad accounts",
	"billing.plan.item.ads": "Create and manage ads in minutes",
	"billing.plan.item.team": "Up to {{limit}} seats for your team",
	"billing.plan.item.dashboard": "Clear and intuitive dashboard data",
	"billing.plan.item.rulesFrequency": "Rules run every {{frequency}} minutes",
	"billing.plan.item.standard.support": "Provide technical support via Email during weekdays",
	"billing.plan.item.professional.support": "Provide technical support via WeChat during weekdays",
	"billing.plan.item.support": "Provide technical support via Email during weekdays",

	"billing.plan.unsubscribe.button": "Unsubscribe",
	"billing.plan.unsubscribe.modal.title": "Confirm Cancellation?",
	"billing.plan.unsubscribe.modal.text":
		"Your subscription will expire on <important>{{day}}th {{month}},{{year}}</important>. If you cancel the subscription, the vouchers that have already been used will not be refunded. Do you still want to cancel the subscription?",
	"billing.plan.unsubscribe.modal.text.trial": "Your subscription will end immediately.",
	"billing.plan.unsubscribe.modal.text.notTrial": "Your subscription will be canceled at the end of your billing period.",
	"billing.plan.unsubscribe.modal.ok": "Confirm",
	"billing.plan.unsubscribe.modal.cancel": "Cancel",
	"billing.plan.unsubscribe.message.success": "Your subscription has been canceled successfully.",
	"billing.plan.reactivate.message.success": "Your subscription plan has been reactivated.",
	"billing.plan.upgrade.button": "Upgrade Plan",

	"billing.payment.cancel.countdown": "The limited time payment expires in",
	"billing.payment.cancel.countdown.last": "",
	"billing.payment.cancel.countdown.minute": "minutes",
	"billing.payment.cancel.countdown.seconds": "seconds",

	"billing.payment.cancel.button": "Cancel payment",
	"billing.payment.cancel.modal.title": "Cancel payment",
	"billing.payment.cancel.modal.text": "Are you sure you want to cancel this payment?",
	"billing.payment.cancel.modal.ok": "Cancel Payment",
	"billing.payment.payNow.button": "Pay Now",

	"billing.pending.title": "Pending Payments",
	"billing.history.title": "Payment History",

	"billing.table.column.invoiceId": "Invoice ID",
	"billing.table.column.plan": "Plan",
	"billing.table.column.plan.standard": "Standard Plan",
	"billing.table.column.plan.professional": "Professional Plan",
	"billing.table.column.amount": "Amount",
	"billing.table.column.paymentType": "Payment Type",
	"billing.table.column.paymentType.monthly": "Pay monthly",
	"billing.table.column.paymentType.upgrade": "Upgrade fee",
	"billing.table.column.paymentType.refund": "Refund",
	"billing.table.column.paymentType.once": "Once",
	"billing.table.column.paymentDate": "Payment Date",
	"billing.table.column.status": "Status",
	"billing.table.column.status.pending": "Payment pending",
	"billing.table.column.status.success": "Payment success",
	"billing.table.column.status.failed": "Payment failed",
	"billing.table.column.status.canceled": "Payment canceled",

	"billing.renew": "Use vouchers to renew",
	"billing.coupon.total": "Total voucher amount:  <important>{{amount}}</important>  USD",
	"billing.coupon.plan": "Plan",
	"billing.coupon.plan.price": "Price",
	"billing.coupon.useCoupon": "Use vouchers",
	"billing.coupon.useCoupon.mesasge": "The actual payment amount must not be less than {{dollar}}  USD.",
	"billing.coupon.useCoupon.payment.total": "Total Amount",

	"billing.coupon.useCoupon.description": "This payment serves as the renewal fee for the next subscription period",

	"billing.plan.Expires": "Expires: {{time}}",
	"billing.plan.Expires.Within seven days.tips":
		"您的专业版套餐将在7天后到期。为避免服务中断，请尽早续订标准版或专业版套餐。如需升级至企业版套餐，请联系客服人员。",

	"billing.reactivate.confirm": "Reactivate Plan",

	"billing.degradation.confirm": "Downgrade Plan",
	"billing.degradation.confirm.tips":
		"You are currently subscribed to the <important>{{Plan}}</important>. To change to the Standard Plan, please adjust your settings as follows:",
	"billing.degradation.confirm.tips.list1":
		"Restrict the number of connected accounts to a maximum of <important>{{count}}</important>",
	"billing.degradation.confirm.tips.list2":
		"Restrict the number of automated rules to a maximum of <important>{{count}}</important>",
	"billing.degradation.confirm.tips.list3":
		"Restrict the number of  ad accounts managed by rules to a maximum of <important>{{count}}</important>",
	"billing.degradation.confirm.tips.list4": "Set the rule to run every <important>{{count}}</important>minutes.",
	"billing.degradation.confirm.tips.list5":
		"Restrict the number of team members to a maximum of <important>{{count}}</important>",
	"billing.degradation.modal.failed.tip": "Reminder",
	"billing.degradation.modal.failed.content.before": "Please",
	"billing.degradation.modal.failed.content.after": "before downgrading the plan."
};
